module.exports = "<img class=\"image\" src=\"./assets/images/main_Courier.jpg\" alt=\"Welcome to SorfML\">"